const STATIC_GENDER_OPTIONS = Object.freeze([
  { id: "89", name: "Male", display_label: "Male" },
  { id: "90", name: "Female", display_label: "Female" },
]);

export function getStaticGenderOptions() {
  return STATIC_GENDER_OPTIONS.map((option) => ({ ...option }));
}

export default STATIC_GENDER_OPTIONS;
